// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import {useState} from 'react';
import etask from 'zetask';

export const use_etask = <t_args extends any[] = [], t_data = any>(fn:
    (...args: t_args)=>etask_t)=>{
    const [state, set_state] = useState({
        loading: false,
        data: null as t_data,
    });
    const exec = (...args: t_args)=>etask(function*(){
        set_state({data: null, loading: true});
        const data: t_data = yield fn(...args);
        set_state({data, loading: false});
    });
    return {state, exec};
};
